import { h } from 'preact'
import { Parti } from '../../../../domain'

type Props = {
  sisteParti: Parti
  nesteParti: Parti
}

export function Close(props: Props) {
  return (
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 375 113">
      <style
        type="text/css"
        dangerouslySetInnerHTML={{
          __html: `.st0{fill:'#26292A';}
  .st1{font-family:'LFT Etica'; font-weight: 700}
  .st2{font-size:22px;}
  .st3{fill-rule:evenodd;clip-rule:evenodd;}
  .st4{opacity:5.000000e-02;fill-rule:evenodd;clip-rule:evenodd;enable-background:new    ;}
  .st5{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}
  .st6{fill-rule:evenodd;clip-rule:evenodd;}
  .st7{fill:none;stroke:#26292A;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}`
        }}
      />
      <g>
        <text
          transform="matrix(1 0 0 1 278 111)"
          class="st0 st1 st2"
          style={{ textAnchor: 'middle' }}
        >
          {props.sisteParti.kortNavn}
        </text>
        <circle class="st3" cx="278" cy="41" r="39" style={{ fill: props.sisteParti.farge }} />
        <path
          class="st4"
          d="M240.5,30.2c-1,3.6-1.6,7.4-1.5,11.3c0.3,21.3,17.4,38.2,38.9,38.4
		c6.7,0.1,13-1.7,18.6-4.7c-3.6,0.9-7.3,1.4-11.1,1.4c-24.7,0-44.9-19.8-44.9-44.2C240.5,31.8,240.5,31,240.5,30.2"
        />
        <circle class="st5" cx="291" cy="35" r="5" />
        <circle class="st5" cx="265" cy="35" r="5" />
        <circle class="st5" cx="278.5" cy="60.5" r="11.5" />
        <text
          transform="matrix(1 0 0 1 167.9998 111)"
          class="st0 st1 st2"
          style={{ textAnchor: 'middle' }}
        >
          {props.nesteParti.kortNavn}
        </text>
        <path
          class="st6"
          d="M205,24c0,0-24.1,10.8-35.1,17c-8.9,5,21.4,32.6,21.4,32.6c-6.1,4-13.5,6.4-21.4,6.4
		C148.4,80,131,62.5,131,41s17.4-39,38.9-39C185.4,2,198.7,11,205,24z"
          style={{ fill: props.nesteParti.farge }}
        />
        <path
          class="st4"
          d="M132.5,30.3c-1,3.6-1.6,7.4-1.5,11.3c0.3,21.3,17.7,38.4,38.9,38.4
		c6.7,0,12.4-1.6,18-4.4c-3.6,0.9-6.7,1.1-10.6,1.1c-24.7,0-44.9-19.8-44.9-44.2C132.5,31.8,132.5,31,132.5,30.3"
        />
        <circle class="st5" cx="175" cy="21" r="5" />
        <line class="st7" x1="113.5" y1="63.5" x2="123.5" y2="63.5" />
        <line class="st7" x1="96.5" y1="48.5" x2="116.5" y2="48.5" />
        <line class="st7" x1="92.5" y1="38.5" x2="102.5" y2="38.5" />
        <line class="st7" x1="106.5" y1="24.5" x2="123.5" y2="24.5" />
      </g>
    </svg>
  )
}
